import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/pages/Layout.vue";
import routerView from "@/components/routerView.vue";
import Home from "@/pages/views/home";
import Group from "@/pages/views/group";
import NotFoundPage from "@/pages/404.vue";
import Estate from "@/pages/views/estate";
import Leader from "@/pages/views/leader";

import TianXi from "@/pages/views/residence/tianXi.vue";
import JinLinXi from "@/pages/views/residence/jinLinXi.vue";
import JinYueXi from "@/pages/views/residence/jinYueXi.vue";
import Office from "@/pages/views/office";
import Hotel from "@/pages/views/hotel";
import Synthesis from "@/pages/views/synthesis";
import Apartment from "@/pages/views/apartment";
import TouristTown from "@/pages/views/touristTown";
import IndustrialPark from "@/pages/views/industrialPark";

import Product from "@/pages/views/news/product.vue";
import Active from "@/pages/views/news/active.vue";
import Love from "@/pages/views/news/love.vue";
import Welfare from "@/pages/views/welfare";
import GroupNews from "@/pages/views/news/group.vue";
import EstateNews from "@/pages/views/news/estate.vue";
import Media from "@/pages/views/news/media.vue";
import SelfMedia from "@/pages/views/news/selfMedia.vue";
import Org from "@/pages/views/news/org.vue";
import NewsDetail from '@/pages/views/news/detail.vue';

import Plan from "@/pages/views/join/plan.vue";
import Strong from "@/pages/views/join/strong.vue";
import Job from "@/pages/views/join/job.vue";
import Talent from "@/pages/views/join/talent.vue";

import Offence from "@/pages/views/info/offence.vue";
import Privacy from "@/pages/views/info/privacy.vue";
import Legal from "@/pages/views/info/legal.vue";

import OkService from "@/pages/views/ok/okService.vue";
import OkInfo from "@/pages/views/ok/okInfo.vue";

import Admin from './admin'

import Login from "@/pages/views/Login.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    children: [  {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/group",
      name: "Group",
      component: Group,
    },
    {
      path: "/estate",
      name: "Estate",
      component: Estate,
    },
    {
      path: "/leaders",
      name: "Leader",
      component: Leader,
    },
    {
      path: "/residence",
      name: "Residence",
      component: routerView,
      redirect: { name: "TianXi" },
      children: [
        {
          path: "1",
          name: "TianXi",
          component: TianXi,
        },
        {
          path: "2",
          name: "JinLinXi",
          component: JinLinXi,
        },
        {
          path: "3",
          name: "JinYueXi",
          component: JinYueXi,
        },
      ],
    },
    {
      path: "/office",
      name: "Office",
      component: Office,
    },
    {
      path: "/hotel",
      name: "Hotel",
      component: Hotel,
    },
    {
      path: "/synthesis",
      name: "Synthesis",
      component: Synthesis,
    },
    {
      path: "/apartment",
      name: "Apartment",
      component: Apartment,
    },
    {
      path: "/touristTown",
      name: "TouristTown",
      component: TouristTown,
    },
    {
      path: "/industrialPark",
      name: "IndustrialPark",
      component: IndustrialPark,
    },
    {
      path: "/news",
      name: "News",
      component: routerView,
      redirect: { name: "Product" },
      children: [
        {
          path: "product",
          name: "Product",
          component: Product,
        },
        {
          path: "active",
          name: "Active",
          component: Active,
        },
        {
          path: "love",
          name: "Love",
          component: Love,
        },
        {
          path: "group",
          name: "GroupNews",
          component: GroupNews,
        },
        {
          path: "estate",
          name: "EstateNews",
          component: EstateNews,
        },
        {
          path: "media",
          name: "Media",
          component: Media,
        },
        {
          path: "selfMedia",
          name: "SelfMedia",
          component: SelfMedia,
        },
        {
          path: "org",
          name: "Org",
          component: Org,
        },
        {
          path: 'detail/:id',
          name: 'NewsDetail',
          component: NewsDetail,
        }
      ],
    },
    {
      path: "/welfare",
      name: "Welfare",
      component: Welfare,
    },
    {
      path: "/join",
      name: "Join",
      component: routerView,
      redirect: { name: "Plan" },
      children: [
        {
          path: "plan",
          name: "Plan",
          component: Plan,
        },
        {
          path: "strong",
          name: "Strong",
          component: Strong,
        },
        {
          path: "job",
          name: "Job",
          component: Job,
        },
        {
          path: "talent",
          name: "Talent",
          component: Talent,
        },
      ],
    },
    {
      path: "/info",
      name: "Info",
      component: routerView,
      redirect: { name: "Offence" },
      children: [
        {
          path: "offence",
          name: "Offence",
          component: Offence,
        },
        {
          path: "privacy",
          name: "Privacy",
          component: Privacy,
        },
        {
          path: "legal",
          name: "Legal",
          component: Legal,
        },
      ],
    },
    {
      path: "/ok",
      name: "OK",
      component: routerView,
      redirect: { name: "OkService" },
      children: [
        {
          path: "service",
          name: "OkService",
          component: OkService,
        },
        {
          path: "info",
          name: "OkInfo",
          component: OkInfo,
        },
      ],
    },]
  },
  ...Admin,
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: "*",
    name: "404",
    component: NotFoundPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 返回期望滚动到的位置
    return { x: 0, y: 0, /** behavior: "smooth" **/ };
  },
});

export default router;
